var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ds-badge',
    _vm.activeHover ? 'ds-badge-active-hover' : 'ds-badge-active-blur',
    { 'ds-badge-active': _vm.active }
  ],style:({
    backgroundColor: _vm.backgroundColor,
    borderColor: _vm.active || _vm.activeHover ? 'transparent' : '#E8ECEF'
  }),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.mark)?_c('div',{class:[
      'mark',
      _vm.activeHover ? 'ds-mark-active-hover' : 'ds-mark-active-blur',
      { 'ds-mark-active': _vm.active }
    ],style:({ backgroundColor: _vm.markColor })}):(_vm.icon)?_c('Icon',{staticClass:"ds-icon",style:({ padding: _vm.iconPadding }),attrs:{"source":_vm.icon,"color":_vm.iconColor,"size":_vm.iconSize}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }